"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setColumnMaxWidthIf = exports.setColumnMaxWidth = void 0;
function setColumnMaxWidth(columnApi, columnIds, newMaxWidth) {
    setColumnMaxWidthIf(columnApi, columnIds, newMaxWidth, function () { return true; });
}
exports.setColumnMaxWidth = setColumnMaxWidth;
function setColumnMaxWidthIf(columnApi, columnIds, newMaxWidth, condition) {
    columnIds.forEach(function (colId) {
        var column = columnApi.getColumn(colId);
        if (column && condition(column)) {
            // We need set maxWidth dynamically before/after autoresize/growToFit.
            // Set this only on column.getColDef().maxWidth not working
            // so we need to set it also on column's private member
            column.maxWidth = newMaxWidth;
            column.getColDef().maxWidth = newMaxWidth;
        }
    });
}
exports.setColumnMaxWidthIf = setColumnMaxWidthIf;
//# sourceMappingURL=agColumnWrapper.js.map